import React, { useState, useEffect } from 'react';
import ProfileMenu from './ProfileMenu';
import { api } from './api';
import NotificationPanel from './NotificationPanel';

const API = 'https://talku.online';
const authH = (extra = {}) => ({ 'Authorization': `Bearer ${localStorage.getItem('talku_token') || ''}`, ...extra });

const NAV_ITEMS = [
  { id: 'Dashboard', label: 'Dashboard', icon: (a) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="7" height="7" rx="2" fill={a?'#fff':'none'} stroke={a?'#fff':'#aaa'} strokeWidth="1.6"/><rect x="14" y="3" width="7" height="7" rx="2" fill={a?'#fff':'none'} stroke={a?'#fff':'#aaa'} strokeWidth="1.6"/><rect x="3" y="14" width="7" height="7" rx="2" fill={a?'#fff':'none'} stroke={a?'#fff':'#aaa'} strokeWidth="1.6"/><rect x="14" y="14" width="7" height="7" rx="2" fill={a?'#fff':'none'} stroke={a?'#fff':'#aaa'} strokeWidth="1.6"/></svg> },
  { id: 'Conversaciones', label: 'Conversaciones', icon: (a) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" fill={a?'#fff':'none'} stroke={a?'#fff':'#aaa'} strokeWidth="1.6" strokeLinejoin="round"/></svg> },
  { id: 'Pedidos', label: 'Pedidos', icon: (a) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" fill={a?'#fff':'none'} stroke={a?'#fff':'#aaa'} strokeWidth="1.6" strokeLinejoin="round"/><line x1="3" y1="6" x2="21" y2="6" stroke={a?'#0a0a0a':'#aaa'} strokeWidth="1.6"/><path d="M16 10a4 4 0 0 1-8 0" stroke={a?'#0a0a0a':'#aaa'} strokeWidth="1.6" strokeLinecap="round"/></svg> },
  { id: 'Contactos', label: 'Contactos', icon: (a) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="4" fill={a?'#fff':'none'} stroke={a?'#fff':'#aaa'} strokeWidth="1.6"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke={a?'#fff':'#aaa'} strokeWidth="1.6" strokeLinecap="round"/></svg> },
  { id: 'Flujos', label: 'Flujos', icon: (a) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="6" height="5" rx="1.5" fill={a?'#fff':'none'} stroke={a?'#fff':'#aaa'} strokeWidth="1.6"/><rect x="15" y="9" width="6" height="5" rx="1.5" fill={a?'#fff':'none'} stroke={a?'#fff':'#aaa'} strokeWidth="1.6"/><rect x="3" y="16" width="6" height="5" rx="1.5" fill={a?'#fff':'none'} stroke={a?'#fff':'#aaa'} strokeWidth="1.6"/><path d="M9 5.5h3a3 3 0 0 1 3 3v3" stroke={a?'#fff':'#aaa'} strokeWidth="1.6" strokeLinecap="round"/><path d="M9 18.5h3a3 3 0 0 0 3-3v-3" stroke={a?'#fff':'#aaa'} strokeWidth="1.6" strokeLinecap="round"/></svg> },
  { id: 'Marketing', label: 'Marketing', icon: (a) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill={a?'#fff':'none'} stroke={a?'#fff':'#aaa'} strokeWidth="1.6" strokeLinejoin="round"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14" stroke={a?'#fff':'#aaa'} strokeWidth="1.6" strokeLinecap="round"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07" stroke={a?'#fff':'#aaa'} strokeWidth="1.6" strokeLinecap="round"/></svg> },
];

const ESTADO_CONFIG = {
  sin_confirmar:  { label:'Sin confirmar',  color:'#d97706', bg:'#fffbeb' },
  por_generar:    { label:'Por generar',    color:'#ea580c', bg:'#fff7ed' },
  despachado:     { label:'Despachado',     color:'#3b82f6', bg:'#eff6ff' },
  en_camino:      { label:'En camino',      color:'#8b5cf6', bg:'#f5f3ff' },
  en_destino:     { label:'En destino',     color:'#6366f1', bg:'#eef2ff' },
  en_reparto:     { label:'En reparto',     color:'#0891b2', bg:'#ecfeff' },
  entregado:      { label:'Entregado',      color:'#16a34a', bg:'#f0fdf4' },
  novedad:        { label:'Novedad',        color:'#ef4444', bg:'#fef2f2' },
  devolucion:     { label:'Devolución',     color:'#dc2626', bg:'#fef2f2' },
  cancelado:      { label:'Cancelado',      color:'#888',    bg:'#f4f4f2' },
  contingencia:   { label:'Pendiente de sync', color:'#b45309', bg:'#fef3c7' },
  paid:           { label:'Pagado',         color:'#16a34a', bg:'#f0fdf4' },
  pending:        { label:'Pendiente',      color:'#d97706', bg:'#fffbeb' },
  refunded:       { label:'Reembolsado',    color:'#888',    bg:'#f4f4f2' },
  voided:         { label:'Anulado',        color:'#888',    bg:'#f4f4f2' },
};

const TIENDAS = ['Todas las tiendas','Tiendas Colombia','Trend Bird','Tokio Tienda'];
const TRANSPORTADORAS = ['Todas','Coordinadora','Interrapidísimo'];
// Métodos de pago reales presentes en /orders (auditados en BD): COD, addi, sistecredito, wompi, mercadopago, openpay
const METODOS_PAGO = ['Todos','Contraentrega / COD','ADDI','Sistecrédito','Wompi','MercadoPago','Openpay'];
// Normaliza el valor crudo de payment_method a una etiqueta canónica legible
const normMetodo = (m) => {
  const k = String(m || '').toLowerCase().replace(/[\s_-]/g,'');
  if (k === 'cod' || k.includes('contraentrega') || k.includes('contrareembolso')) return 'Contraentrega / COD';
  if (k === 'addi') return 'ADDI';
  if (k === 'sistecredito') return 'Sistecrédito';
  if (k === 'wompi') return 'Wompi';
  if (k === 'mercadopago') return 'MercadoPago';
  if (k === 'openpay') return 'Openpay';
  return m || '—';
};
const RANGE_DAYS = { hoy: 1, '7d': 7, '30d': 30, all: null };
const fmt = (n) => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}).format(n);

const WaIcon = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="#22c55e"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>;
const IgIcon = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none"><rect x="2" y="2" width="20" height="20" rx="5" fill="url(#ig2)"/><circle cx="12" cy="12" r="4.5" stroke="#fff" strokeWidth="1.5" fill="none"/><circle cx="17.5" cy="6.5" r="1" fill="#fff"/><defs><linearGradient id="ig2" x1="2" y1="22" x2="22" y2="2" gradientUnits="userSpaceOnUse"><stop stopColor="#f9ce34"/><stop offset="0.3" stopColor="#ee2a7b"/><stop offset="1" stopColor="#6228d7"/></linearGradient></defs></svg>;
const FbIcon = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="#1877f2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>;
const CanalIcon = ({ c }) => c === 'wa' ? <WaIcon/> : c === 'ig' ? <IgIcon/> : <FbIcon/>;

// Miniatura real del producto con fallback elegante (gradiente violeta + icono paquete)
const ProdThumb = ({ src, name, size = 40, radius = 10 }) => {
  const [err, setErr] = useState(false);
  const show = src && !err;
  return (
    <div style={{width:size,height:size,minWidth:size,borderRadius:radius,flexShrink:0,overflow:'hidden',border:'1px solid #ececea',background:show?'#f4f4f2':'linear-gradient(135deg,#efeafc 0%,#f4f1fb 100%)',display:'flex',alignItems:'center',justifyContent:'center'}}>
      {show
        ? <img src={src} alt={name||''} loading="lazy" onError={()=>setErr(true)} style={{width:'100%',height:'100%',objectFit:'cover',display:'block'}}/>
        : <svg width={Math.round(size*0.48)} height={Math.round(size*0.48)} viewBox="0 0 24 24" fill="none" stroke="#b7aee8" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>}
    </div>
  );
};

const getEstado = (o) => o.estado || 'sin_confirmar';

export default function Orders({ user, onNav, onLogout }) {
  const [activeNav, setActiveNav] = useState('Pedidos');
  const [showNotifs, setShowNotifs] = useState(false);
  const [tabEstado, setTabEstado] = useState('todos');
  const [tienda, setTienda] = useState('Todas las tiendas');
  const [transportadora, setTransportadora] = useState('Todas');
  const [metodoPago, setMetodoPago] = useState('Todos');
  const [dateRange, setDateRange] = useState('all');
  const [search, setSearch] = useState('');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderMenuId, setOrderMenuId] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFilters, setShowFilters] = useState(false);
  const [showNuevoPedido, setShowNuevoPedido] = useState(false);
  const [nuevoPedido, setNuevoPedido] = useState({ producto:'', variante:'', qty:1, cliente:'', telefono:'', direccion:'', ciudad:'', metodo:'COD', tienda:'Tiendas Colombia', transportadora:'Coordinadora' });
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });

  const [porGenerar, setPorGenerar] = useState([]);
  const [loadingPorGenerar, setLoadingPorGenerar] = useState(false);

  const [abandonados, setAbandonados] = useState([]);
  const [loadingAbandonados, setLoadingAbandonados] = useState(false);
  const [selectedAbandoned, setSelectedAbandoned] = useState(null);
  const [recoverLoading, setRecoverLoading] = useState(false);
  const [recoverMsg, setRecoverMsg] = useState('');

  const [showNexusModal, setShowNexusModal] = useState(false);
  const [nexusOrderInfo, setNexusOrderInfo] = useState(null);
  const [nexusForm, setNexusForm] = useState({});
  const [nexusLoading, setNexusLoading] = useState(false);
  const [nexusMsg, setNexusMsg] = useState('');
  const [nexusNovedades, setNexusNovedades] = useState([]);
  const [resolving, setResolving] = useState(null);
  const [selectedSolucion, setSelectedSolucion] = useState(null);
  const [detalleForm, setDetalleForm] = useState({});
  const [storeDomain, setStoreDomain] = useState('');
  const [syncing, setSyncing] = useState(false);
  const [syncMsg, setSyncMsg] = useState('');
  const [drawerEstadoOpen, setDrawerEstadoOpen] = useState(false);
  useEffect(() => { setDrawerEstadoOpen(false); }, [selectedOrder?.uid]);

  // Fase 2: sincronizar un pedido de contingencia a Nexus (reutiliza /contingency/sync/{id})
  const syncContingency = async () => {
    if (!selectedOrder || selectedOrder.source !== 'contingency') return;
    const cid = String(selectedOrder.uid || '').split(':')[1];
    if (!cid) return;
    setSyncing(true); setSyncMsg('');
    try {
      const r = await fetch(`${API}/contingency/sync/${cid}`, { method: 'POST', headers: authH({ 'Content-Type': 'application/json' }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { setSyncMsg(d.detail || `Error ${r.status}`); setSyncing(false); return; }
      if ((d.synced === 0) && (d.errors > 0)) {
        const err = (d.results && d.results[0] && (d.results[0].error || d.results[0].message)) || 'No se pudo sincronizar (¿Nexus disponible?).';
        setSyncMsg(err); setSyncing(false); return;
      }
      // Éxito: refrescar lista (dedup mostrará el pedido ya como orders y ocultará el contingente)
      const data = await api.getOrders({ limit: 50 });
      if (data.orders) setOrders(data.orders);
      setSelectedOrder(null);
    } catch { setSyncMsg('Error de conexión al sincronizar.'); }
    setSyncing(false);
  };
  useEffect(() => { fetch(`${API}/stores/`, { headers: authH() }).then(r=>r.json()).then(d=>{ if (Array.isArray(d) && d.length) setStoreDomain(d[0].domain); }).catch(()=>{}); }, []); // eslint-disable-line
  useEffect(() => { setSyncMsg(''); }, [selectedOrder?.uid]);

  const handleNav = (id, data) => { setActiveNav(id); if (onNav) onNav(id, data); };

  const recoverAbandoned = async (ch) => {
    setRecoverLoading(true); setRecoverMsg('');
    try {
      const res = await fetch(`${API}/orders/abandoned/recover`, {
        method: 'POST',
        headers: authH({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ phone: ch.phone, nombre: ch.name }),
      });
      const d = await res.json();
      if (d.ok) setRecoverMsg('Template enviado correctamente');
      else setRecoverMsg(`Error: ${d.detail || 'Error'}`);
    } catch { setRecoverMsg('Error de conexion'); }
    finally { setRecoverLoading(false); }
  };

  useEffect(() => {
    setLoading(true);
    api.getOrders({ limit: 50 })
      .then(data => {
        if (data.orders) setOrders(data.orders);
        setLoading(false);
      })
      .catch(() => setLoading(false));
    setLoadingPorGenerar(true);
    api.getOrdersPorGenerar()
      .then(data => {
        if (data.orders) setPorGenerar(data.orders);
        setLoadingPorGenerar(false);
      })
      .catch(() => setLoadingPorGenerar(false));
  }, []);

  useEffect(() => {
    if (selectedOrder?.shopify_id) {
      api.getOrderFulfillments(selectedOrder.shopify_id).then(data => {
        if (data.guia && data.guia !== '—') {
          setSelectedOrder(prev => ({
            ...prev,
            guia: data.guia,
            transportadora: data.transportadora,
            tracking_url: data.tracking_url
          }));
        }
      }).catch(() => {});
      if (selectedOrder.nexus_order_id) {
        setNexusOrderInfo({
          has_nexus: true,
          nexus_order_id: selectedOrder.nexus_order_id,
          tracking_number: selectedOrder.guia_nexus || null,
          shopify_order_id: String(selectedOrder.shopify_id),
        });
      } else {
        setNexusOrderInfo({ has_nexus: false });
      }
    } else {
      setNexusOrderInfo(null);
    }
  }, [selectedOrder?.shopify_id]);

  const openNexusModal = async (shopifyOrderId) => {
    setNexusMsg(''); setNexusLoading(true); setShowNexusModal(true);
    const order = selectedOrder;
    const hasNexus = !!(order?.nexus_order_id);
    const nexusInfo = {
      has_nexus: hasNexus,
      nexus_order_id: order?.nexus_order_id || null,
      tracking_number: order?.guia_nexus || null,
      shopify_order_id: String(shopifyOrderId),
    };
    setNexusOrderInfo(nexusInfo);

    if (hasNexus) {
      let nexusDetail = null;
      try {
        const dr = await fetch(`${API}/nexus/orders/${shopifyOrderId}/detail`, { headers: authH() });
        if (dr.ok) nexusDetail = await dr.json();
      } catch(_) {}
      setNexusForm({
        customer_name:       nexusDetail?.customer_name || order?.cliente || '',
        customer_phone:      nexusDetail?.customer_phone || order?.telefono || '',
        shipping_address:    nexusDetail?.shipping_address || order?.direccion || '',
        city:                nexusDetail?.city || order?.ciudad || '',
        state:               nexusDetail?.state || order?.provincia || '',
        content_description: nexusDetail?.content_description || order?.producto || '',
        total_amount:        nexusDetail?.total_amount || String(order?.valor || ''),
      });
    }
    if (hasNexus) {
      try {
        const nr = await fetch(`${API}/nexus/orders/${shopifyOrderId}/novelties`, { headers: authH() });
        if (nr.ok) {
          const nd = await nr.json();
          setNexusNovedades((nd.novedades || []).filter(n => !n.resuelta));
        }
      } catch(_) {}
    }
    setNexusLoading(false);
  };

  const resolveNovelty = async (noveltyId) => {
    if (!selectedSolucion || !nexusOrderInfo?.shopify_order_id) return;
    setResolving(noveltyId);
    try {
      const payload = { id_solucion: selectedSolucion.id };
      const det = Object.fromEntries(Object.entries(detalleForm).filter(([,v]) => v));
      if (Object.keys(det).length > 0) payload.detalle_solucion = det;
      const r = await fetch(`${API}/nexus/orders/${nexusOrderInfo.shopify_order_id}/novelties/${noveltyId}/resolve`, {
        method: 'POST', headers: authH({ 'Content-Type': 'application/json' }), body: JSON.stringify(payload),
      });
      if (r.ok) {
        setNexusNovedades(prev => prev.filter(n => (n.id || n.codigo) !== noveltyId));
        setSelectedSolucion(null);
        setDetalleForm({});
        setNexusMsg('Novedad resuelta');
      } else {
        const d = await r.json().catch(() => ({}));
        setNexusMsg(`Error: ${d.detail || 'No se pudo resolver'}`);
      }
    } catch(_) { setNexusMsg('Error de conexion'); }
    setResolving(null);
  };

  const nexusGenerateGuide = async () => {
    if (!nexusOrderInfo?.shopify_order_id) return;
    setNexusLoading(true); setNexusMsg('');
    try {
      const updateFields = Object.fromEntries(Object.entries(nexusForm).filter(([,v]) => v !== '' && v !== null && v !== undefined));
      if (Object.keys(updateFields).length > 0) {
        await fetch(`${API}/nexus/orders/${nexusOrderInfo.shopify_order_id}`, {
          method: 'PATCH',
          headers: authH({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(updateFields),
        });
      }
      const res = await fetch(`${API}/nexus/orders/${nexusOrderInfo.shopify_order_id}/generate-guide`, { method: 'POST', headers: authH() });
      const d = await res.json();
      if (d.guide_number) {
        const label = res.status === 409 ? 'Ya tiene guia activa' : 'Guia generada';
        setNexusMsg(`${label}: ${d.guide_number}`);
        setNexusOrderInfo(prev => ({ ...prev, tracking_number: d.guide_number, carrier_status: 'shipped' }));
        setLoading(true);
        api.getOrders({ limit: 50 }).then(data => { if (data.orders) setOrders(data.orders); setLoading(false); }).catch(() => setLoading(false));
      } else {
        setNexusMsg(`Error: ${d.message || d.detail || 'Error generando guia'}`);
      }
    } catch(e) {
      setNexusMsg('Error de conexion');
    } finally { setNexusLoading(false); }
  };

  const baseList = tabEstado === 'por_generar' ? porGenerar : orders;

  const filtered = baseList.filter(o => {
    const estado = getEstado(o);
    if (tabEstado !== 'todos' && tabEstado !== 'por_generar' && estado !== tabEstado) return false;
    if (tienda !== 'Todas las tiendas' && o.tienda !== tienda) return false;
    if (transportadora !== 'Todas' && o.transportadora !== transportadora) return false;
    if (metodoPago !== 'Todos' && normMetodo(o.metodo) !== metodoPago) return false;
    if (search) {
      const s = search.toLowerCase();
      if (!o.id?.toLowerCase().includes(s) && !o.cliente?.toLowerCase().includes(s) && !o.producto?.toLowerCase().includes(s) && !o.telefono?.replace(/\D/g,'').includes(s.replace(/\D/g,''))) return false;
    }
    return true;
  });


  const totalVentas = orders.filter(o=>getEstado(o)!=='cancelado').reduce((s,o)=>s+(o.valor||0),0);
  const totalPedidos = orders.length;
  const enCamino = orders.filter(o=>['despachado','en_camino','en_destino','en_reparto'].includes(getEstado(o))).length;
  const entregados = orders.filter(o=>getEstado(o)==='entregado').length;
  const novedades = orders.filter(o=>getEstado(o)==='novedad').length;
  const sinDespachar = orders.filter(o=>['sin_confirmar','por_generar','contingencia'].includes(getEstado(o)) || o.estado_envio==='sin_despachar').length;
  const despachados = orders.filter(o=>['despachado','en_camino','en_destino','en_reparto'].includes(getEstado(o))).length;
  const pendientes = porGenerar.length;

  // Recarga por rango de fechas (backend soporta created_at_min en GET /orders)
  const applyDateRange = (rk) => {
    setDateRange(rk);
    const days = RANGE_DAYS[rk];
    const params = { limit: 50 };
    if (days) params.created_at_min = new Date(Date.now() - days*86400000).toISOString();
    setLoading(true);
    api.getOrders(params).then(d=>{ if(d.orders) setOrders(d.orders); setLoading(false); }).catch(()=>setLoading(false));
  };

  const changeEstado = (id, estado) => {
    setOrders(prev => prev.map(o => o.id===id ? {...o, estado} : o));
    setOrderMenuId(null);
  };

  const TABS = [
    { id:'todos',          label:'Todos',          count: orders.length },
    { id:'sin_confirmar',  label:'Sin confirmar',   count: orders.filter(o=>getEstado(o)==='sin_confirmar').length },
    { id:'por_generar',    label:'Por generar',     count: porGenerar.length },
    { id:'despachado',     label:'Despachado',      count: orders.filter(o=>getEstado(o)==='despachado').length },
    { id:'en_camino',      label:'En camino',       count: orders.filter(o=>getEstado(o)==='en_camino').length },
    { id:'en_destino',     label:'En destino',      count: orders.filter(o=>getEstado(o)==='en_destino').length },
    { id:'en_reparto',     label:'En reparto',      count: orders.filter(o=>getEstado(o)==='en_reparto').length },
    { id:'entregado',      label:'Entregado',       count: entregados },
    { id:'novedad',        label:'Novedad',         count: novedades },
    { id:'devolucion',     label:'Devolución',      count: orders.filter(o=>getEstado(o)==='devolucion').length },
    { id:'cancelado',      label:'Cancelado',       count: orders.filter(o=>getEstado(o)==='cancelado').length },
    { id:'abandonados',    label:'Abandonados',     count: abandonados.length, special: true },
  ];

  const loadAbandonados = () => {
    setLoadingAbandonados(true);
    api.getAbandonedCheckouts(5).then(d => {
      setAbandonados(d.checkouts || []);
      setLoadingAbandonados(false);
    }).catch(() => setLoadingAbandonados(false));
  };

  const splitView = !!selectedOrder && tabEstado !== 'abandonados';

  return (
    <>
      <style>{`
        @import url('https://fonts.cdnfonts.com/css/sf-pro-display');
        *{box-sizing:border-box;margin:0;padding:0;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;}
        body{overflow:hidden;}
        .ord-app{display:flex;flex-direction:column;flex:1;min-height:0;background:#F5F5F3;}
        .ord-body{display:flex;flex:1;overflow:hidden;}
        .ord-main{flex:1;display:flex;flex-direction:column;overflow:hidden;}
        .ord-content{flex:1;overflow-y:auto;padding:28px 32px 40px;}
        .ord-content::-webkit-scrollbar{width:5px;}
        .ord-content::-webkit-scrollbar-track{background:transparent;}
        .ord-content::-webkit-scrollbar-thumb{background:#ddd;border-radius:3px;}
        .ord-wrap{max-width:1400px;margin:0 auto;}

        /* Header de pagina */
        .page-head{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;margin-bottom:24px;}
        .page-title{font-size:31px;font-weight:700;color:#0F0F10;letter-spacing:-0.9px;line-height:1.1;}
        .page-sub{font-size:13px;color:#6B7280;margin-top:6px;font-weight:500;}
        .daterange{height:40px;padding:0 14px;border-radius:12px;border:1px solid #E8E8E8;background:#fff;font-size:13px;font-weight:600;font-family:inherit;color:#0F0F10;outline:none;cursor:pointer;transition:border-color 0.25s;}
        .daterange:focus{border-color:#6D5AE0;}

        /* KPIs */
        .metrics-row{display:grid;grid-template-columns:repeat(6,1fr);gap:14px;margin-bottom:24px;}
        .m-card{border-radius:18px;padding:20px;background:#fff;border:1px solid #E8E8E8;min-height:155px;display:flex;flex-direction:column;transition:border-color 0.25s;}
        .m-card:hover{border-color:#dadada;}
        .kpi-ic{width:40px;height:40px;border-radius:11px;display:flex;align-items:center;justify-content:center;margin-bottom:16px;}
        .m-label{font-size:11px;color:#6B7280;margin-bottom:8px;font-weight:600;}
        .m-val{font-size:27px;font-weight:700;color:#0F0F10;letter-spacing:-1px;line-height:1;}
        .m-sub{font-size:11px;margin-top:8px;font-weight:500;color:#9CA3AF;}

        /* Barra de estados + filtros */
        .fbar{background:#fff;border-radius:18px;padding:16px 18px;border:1px solid #E8E8E8;margin-bottom:24px;}
        .fbtn{display:flex;align-items:center;gap:7px;padding:0 16px;height:40px;border-radius:12px;border:1px solid #E8E8E8;background:#fff;font-size:13px;font-weight:600;color:#6B7280;cursor:pointer;font-family:inherit;transition:all 0.2s;white-space:nowrap;}
        .fbtn:hover{background:#f8f8f6;border-color:#dadada;}
        .fbtn:active{transform:scale(0.98);}
        .fbtn--primary{background:#0F0F10;color:#fff;border-color:#0F0F10;}
        .fbtn--primary:hover{background:#26262a;}
        .tabs{display:flex;gap:4px;overflow-x:auto;padding-bottom:4px;}
        .tabs::-webkit-scrollbar{height:0;}
        .tab{font-size:13px;padding:0 14px;height:36px;border-radius:10px;border:none;background:transparent;color:#6B7280;cursor:pointer;font-family:inherit;font-weight:600;white-space:nowrap;transition:all 0.2s;display:flex;align-items:center;gap:7px;}
        .tab:hover{background:#F5F5F3;color:#0F0F10;}
        .tab--active{background:#111827;color:#fff;}
        .tab__count{font-size:11px;padding:1px 7px;border-radius:999px;background:rgba(255,255,255,0.22);font-weight:700;}
        .tab:not(.tab--active) .tab__count{background:#F0F0F0;color:#9CA3AF;}
        .srow{display:flex;align-items:center;gap:10px;margin-top:14px;padding-top:14px;border-top:1px solid #F0F0F0;}
        .sbox{display:flex;align-items:center;gap:10px;background:#fff;border:1px solid #E8E8E8;border-radius:12px;padding:0 14px;height:40px;flex:1;transition:border-color 0.2s;}
        .sbox:focus-within{border-color:#6D5AE0;}
        .sbox input{background:none;border:none;outline:none;font-size:13px;color:#0F0F10;font-family:inherit;width:100%;font-weight:500;}
        .sbox input::placeholder{color:#9CA3AF;}
        .fsel{height:40px;padding:0 14px;border-radius:12px;border:1px solid #E8E8E8;background:#fff;font-size:13px;font-weight:600;font-family:inherit;color:#6B7280;outline:none;cursor:pointer;transition:border-color 0.2s;}
        .fsel:focus{border-color:#6D5AE0;}

        /* Layout dos columnas: tabla + drawer persistente */
        .ord-split{display:flex;gap:24px;align-items:flex-start;}
        .ord-left{flex:1;min-width:0;}

        .tw{background:#fff;border-radius:18px;border:1px solid #E8E8E8;overflow:hidden;}
        .tw__body{overflow-y:auto;max-height:calc(100vh - 430px);}
        .tw__body::-webkit-scrollbar{width:5px;}
        .tw__body::-webkit-scrollbar-track{background:transparent;}
        .tw__body::-webkit-scrollbar-thumb{background:#e0e0de;border-radius:3px;}
        .tw__body::-webkit-scrollbar-thumb:hover{background:#ccc;}
        .tw__hdr{display:grid;grid-template-columns:var(--tw-cols);gap:0;padding:0 20px;height:44px;align-items:center;border-bottom:1px solid #F0F0F0;}
        .tw__th{font-size:10px;font-weight:700;color:#9CA3AF;text-transform:uppercase;letter-spacing:0.1em;white-space:nowrap;}
        .tw__row{display:grid;grid-template-columns:var(--tw-cols);gap:0;padding:0 20px;height:72px;align-items:center;border-bottom:1px solid #F0F0F0;transition:background 0.15s;cursor:pointer;position:relative;}
        .tw__row:hover{background:#FAFAF9;}
        .tw__row:hover .rdots{opacity:1;}
        .tw__row:last-child{border-bottom:none;}
        .tw__row--sel{background:#F6F4FF;}
        .tw__td{font-size:13px;color:#0F0F10;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-right:8px;font-weight:500;}
        .tw__td--muted{color:#9CA3AF;font-size:12px;font-weight:500;}
        .tw{--tw-cols:28px 96px 1.4fr 2fr 1fr 116px 92px 44px;}
        .tw--split{--tw-cols:28px 84px 1.2fr 1.8fr 1fr 116px 44px;}
        .badge{font-size:10px;padding:4px 11px;border-radius:999px;font-weight:700;display:inline-flex;align-items:center;gap:5px;white-space:nowrap;letter-spacing:0.02em;}

        /* Drawer persistente (columna derecha) */
        .dpanel{width:28%;min-width:360px;max-width:400px;background:#fff;border:1px solid #E8E8E8;border-radius:18px;overflow-y:auto;max-height:calc(100vh - 200px);position:sticky;top:0;flex-shrink:0;}
        .dpanel::-webkit-scrollbar{width:5px;}
        .dpanel::-webkit-scrollbar-thumb{background:#e0e0de;border-radius:3px;}
        .dp-hdr{display:flex;justify-content:space-between;align-items:flex-start;padding:20px 20px 16px;border-bottom:1px solid #F0F0F0;position:sticky;top:0;background:#fff;z-index:2;}
        .dp-title{font-size:19px;font-weight:700;color:#0F0F10;letter-spacing:-0.4px;}
        .dp-x{width:32px;height:32px;border-radius:10px;border:1px solid #E8E8E8;background:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:17px;color:#9CA3AF;line-height:1;transition:all 0.2s;flex-shrink:0;}
        .dp-x:hover{background:#F5F5F3;color:#6B7280;}
        .dp-body{padding:20px;display:flex;flex-direction:column;gap:24px;}
        .dp-sec{display:flex;flex-direction:column;gap:12px;}
        .dp-sec-h{display:flex;align-items:center;gap:8px;font-size:11px;font-weight:700;color:#9CA3AF;text-transform:uppercase;letter-spacing:0.1em;}
        .dp-card{background:#fff;border:1px solid #ECECEC;border-radius:14px;padding:16px;}
        .dp-row{display:flex;justify-content:space-between;align-items:baseline;gap:12px;}
        .dp-row + .dp-row{margin-top:12px;}
        .dp-lbl{font-size:12px;color:#6B7280;font-weight:500;}
        .dp-val{font-size:13px;color:#0F0F10;font-weight:600;text-align:right;word-break:break-word;}
        .dp-btn{height:40px;padding:0 14px;border-radius:12px;font-size:13px;font-weight:600;cursor:pointer;font-family:inherit;border:1px solid #E8E8E8;background:#fff;color:#0F0F10;transition:all 0.2s;display:flex;align-items:center;justify-content:center;gap:7px;}
        .dp-btn:hover{background:#F5F5F3;}
        .dp-btn--sm{height:34px;font-size:12px;padding:0 12px;}
        .dp-btn--primary{background:#0F0F10;color:#fff;border-color:#0F0F10;}
        .dp-btn--primary:hover{background:#26262a;}
        .dp-btn--lav{background:#6D5AE0;color:#fff;border-color:#6D5AE0;}
        .dp-btn--lav:hover{filter:brightness(1.08);}
        .dp-btn--danger{background:#fff;color:#DC2626;border-color:#f3d0d0;}
        .dp-btn--danger:hover{background:#fef2f2;}
        /* Timeline historial */
        .tl{position:relative;padding-left:22px;}
        .tl-item{position:relative;padding-bottom:16px;}
        .tl-item:last-child{padding-bottom:0;}
        .tl-item::before{content:'';position:absolute;left:-16px;top:4px;width:9px;height:9px;border-radius:50%;background:#6D5AE0;border:2px solid #fff;box-shadow:0 0 0 1px #ECECEC;}
        .tl-item::after{content:'';position:absolute;left:-12px;top:14px;bottom:0;width:1px;background:#ECECEC;}
        .tl-item:last-child::after{display:none;}
        .tl-t{font-size:12px;font-weight:600;color:#0F0F10;}
        .tl-d{font-size:11px;color:#9CA3AF;margin-top:2px;}
        .nov-dot{width:7px;height:7px;border-radius:50%;background:#ef4444;flex-shrink:0;animation:pulse-dot 2s ease-in-out infinite;}
        @keyframes pulse-dot{0%,100%{opacity:1;transform:scale(1);}50%{opacity:0.5;transform:scale(1.4);}}
        .rdots{opacity:0.3;transition:opacity 0.25s cubic-bezier(0.32,0.72,0,1);}
        .rmenu{display:flex;align-items:center;gap:10px;padding:10px 12px;border-radius:10px;cursor:pointer;font-size:13px;color:#0a0a0a;font-weight:500;transition:background 0.2s;}
        .rmenu:hover{background:#f6f6f4;}
        .rmenu--danger{color:#ef4444;}

        .mov{position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:500;display:flex;align-items:center;justify-content:center;animation:ov-in 0.2s ease-out;}
        @keyframes ov-in{from{opacity:0}to{opacity:1}}
        .mod{background:#fff;border-radius:24px;width:540px;max-height:85vh;overflow-y:auto;padding:32px;box-shadow:0 32px 80px rgba(0,0,0,0.18),0 0 0 1px rgba(0,0,0,0.03);animation:mod-up 0.35s cubic-bezier(0.32,0.72,0,1);}
        @keyframes mod-up{from{opacity:0;transform:translateY(20px) scale(0.97)}to{opacity:1;transform:none}}
        .mod::-webkit-scrollbar{width:5px;}
        .mod::-webkit-scrollbar-track{background:transparent;}
        .mod::-webkit-scrollbar-thumb{background:#e0e0de;border-radius:3px;}
        .mod__hdr{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:28px;}
        .mod__title{font-size:22px;font-weight:800;color:#0a0a0a;letter-spacing:-0.6px;}
        .mod__close{width:36px;height:36px;border-radius:12px;border:1.5px solid #e8e8e6;background:#f8f8f6;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:18px;color:#999;line-height:1;transition:all 0.35s cubic-bezier(0.32,0.72,0,1);}
        .mod__close:hover{background:#f0f0ee;border-color:#d4d4d2;transform:rotate(90deg);color:#555;}
        .mod__sec{margin-bottom:24px;}
        .mod__sec-title{font-size:10px;font-weight:700;color:#bbb;text-transform:uppercase;letter-spacing:0.14em;margin-bottom:14px;}
        .mod__row{display:flex;justify-content:space-between;margin-bottom:10px;padding:2px 0;}
        .mod__label{font-size:13px;color:#999;font-weight:500;}
        .mod__value{font-size:13px;font-weight:600;color:#0a0a0a;text-align:right;}
        .mod__acts{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:24px;}
        .mod__btn{padding:12px;border-radius:14px;font-size:13px;font-weight:700;cursor:pointer;border:none;font-family:inherit;transition:all 0.3s cubic-bezier(0.32,0.72,0,1);}
        .mod__btn:hover{transform:translateY(-1px);}
        .mod__btn:active{transform:translateY(0) scale(0.97);}

        /* Drawer lateral derecho (detalle de pedido) — reutiliza los estilos internos .mod__* */
        .drw-ov{position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:500;display:flex;justify-content:flex-end;animation:ov-in 0.2s ease-out;}
        .drw{background:#fff;width:500px;max-width:100%;height:100%;overflow-y:auto;padding:32px;box-shadow:-24px 0 60px rgba(0,0,0,0.16),-1px 0 0 rgba(0,0,0,0.04);border-radius:24px 0 0 24px;animation:drw-in 0.34s cubic-bezier(0.32,0.72,0,1);}
        @keyframes drw-in{from{transform:translateX(100%)}to{transform:translateX(0)}}
        .drw::-webkit-scrollbar{width:5px;}
        .drw::-webkit-scrollbar-track{background:transparent;}
        .drw::-webkit-scrollbar-thumb{background:#e0e0de;border-radius:3px;}

        /* Responsive */
        @media (max-width:1280px){
          .metrics-row{grid-template-columns:repeat(3,1fr);}
          .dpanel{min-width:320px;width:34%;}
        }
        @media (max-width:1024px){
          .metrics-row{grid-template-columns:repeat(2,1fr);}
          .ord-split{flex-direction:column;}
          .dpanel{width:100%;max-width:100%;min-width:0;position:static;max-height:none;}
          .ord-left{width:100%;}
          .tw{overflow-x:auto;}
          .tw__hdr,.tw__row{min-width:760px;}
          .tw--split .tw__hdr,.tw--split .tw__row{min-width:680px;}
        }
        @media (max-width:560px){
          .ord-content{padding:20px 16px 32px;}
          .m-val{font-size:23px;}
          .page-title{font-size:26px;}
          .srow{flex-wrap:wrap;}
          .srow .fsel,.srow .fbtn{flex:1;}
        }

        .ld{display:flex;align-items:center;justify-content:center;padding:72px;color:#bbb;font-size:14px;gap:12px;font-weight:500;}
        @keyframes spin{to{transform:rotate(360deg)}}
        .spin{width:22px;height:22px;border:2.5px solid #e8e8e6;border-top-color:#6D5AE0;border-radius:50%;animation:spin 0.8s cubic-bezier(0.32,0.72,0,1) infinite;}

        .nxinp{width:100%;padding:10px 14px;border:1.5px solid #e8e8e6;border-radius:12px;fontSize:13px;font-family:inherit;outline:none;transition:border-color 0.25s cubic-bezier(0.32,0.72,0,1);}
        .nxinp:focus{border-color:#6D5AE0;box-shadow:0 0 0 3px rgba(109,90,224,0.08);}
      `}</style>

      <div className="ord-app">
        <div className="ord-body">
          <div className="ord-main">
          <div className="ord-content">
            {orderMenuId && <div style={{position:'fixed',inset:0,zIndex:499}} onClick={()=>setOrderMenuId(null)}/>}
            {orderMenuId && (
              <div style={{position:'fixed',top:menuPos.top,left:menuPos.left,background:'#fff',border:'1.5px solid #e8e8e6',borderRadius:16,padding:8,width:220,boxShadow:'0 12px 48px rgba(0,0,0,0.12),0 0 0 1px rgba(0,0,0,0.03)',zIndex:500,animation:'mod-up 0.2s cubic-bezier(0.32,0.72,0,1)'}} onClick={e=>e.stopPropagation()}>
                <div style={{fontSize:10,fontWeight:700,color:'#bbb',textTransform:'uppercase',letterSpacing:'0.12em',padding:'6px 12px 10px'}}>Cambiar estado</div>
                {['despachado','en_camino','en_destino','en_reparto','entregado','novedad','devolucion','cancelado'].map(k=>(
                  <div key={k} className="rmenu" onClick={()=>changeEstado(orderMenuId,k)}>
                    <div style={{width:8,height:8,borderRadius:'50%',background:ESTADO_CONFIG[k].color,flexShrink:0}}/>{ESTADO_CONFIG[k].label}
                  </div>
                ))}
                <div style={{borderTop:'1.5px solid #f0f0ee',margin:'6px 0'}}/>
                <div className="rmenu" onClick={()=>{setSelectedOrder(orders.find(o=>o.id===orderMenuId));setOrderMenuId(null);}}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="12"/><circle cx="12" cy="16" r="0.5" fill="#888"/></svg>Ver detalle
                </div>
                <div className="rmenu" onClick={()=>{handleNav('Conversaciones', orders.find(o=>o.id===orderMenuId)?.telefono);setOrderMenuId(null);}}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="1.8" strokeLinecap="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>Abrir conversacion
                </div>
                <div className="rmenu rmenu--danger" onClick={()=>changeEstado(orderMenuId,'cancelado')}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="9"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>Cancelar pedido
                </div>
              </div>
            )}

            {showFilters && (
              <div style={{position:'fixed',inset:0,zIndex:400,background:'rgba(0,0,0,0.35)',animation:'ov-in 0.2s ease-out'}} onClick={()=>setShowFilters(false)}>
                <div style={{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%,-50%)',background:'#fff',borderRadius:24,padding:28,width:480,boxShadow:'0 32px 80px rgba(0,0,0,0.18)',animation:'mod-up 0.3s cubic-bezier(0.32,0.72,0,1)'}} onClick={e=>e.stopPropagation()}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
                    <div style={{fontSize:18,fontWeight:800,color:'#0a0a0a',letterSpacing:'-0.5px'}}>Filtros avanzados</div>
                    <div className="mod__close" onClick={()=>setShowFilters(false)}>x</div>
                  </div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
                    {[
                      {label:'Método de pago',el:<select value={metodoPago} onChange={e=>setMetodoPago(e.target.value)} style={{width:'100%',padding:'10px 14px',borderRadius:12,border:'1.5px solid #e8e8e6',fontSize:13,fontFamily:'inherit',outline:'none',fontWeight:500,transition:'border-color 0.25s'}}>{METODOS_PAGO.map(t=><option key={t}>{t}</option>)}</select>},
                      {label:'Tienda',el:<select value={tienda} onChange={e=>setTienda(e.target.value)} style={{width:'100%',padding:'10px 14px',borderRadius:12,border:'1.5px solid #e8e8e6',fontSize:13,fontFamily:'inherit',outline:'none',fontWeight:500,transition:'border-color 0.25s'}}>{TIENDAS.map(t=><option key={t}>{t}</option>)}</select>},
                      {label:'Transportadora',el:<select value={transportadora} onChange={e=>setTransportadora(e.target.value)} style={{width:'100%',padding:'10px 14px',borderRadius:12,border:'1.5px solid #e8e8e6',fontSize:13,fontFamily:'inherit',outline:'none',fontWeight:500,transition:'border-color 0.25s'}}>{TRANSPORTADORAS.map(t=><option key={t}>{t}</option>)}</select>},
                      {label:'Rango de fechas',el:<select value={dateRange} onChange={e=>applyDateRange(e.target.value)} style={{width:'100%',padding:'10px 14px',borderRadius:12,border:'1.5px solid #e8e8e6',fontSize:13,fontFamily:'inherit',outline:'none',fontWeight:500,transition:'border-color 0.25s'}}><option value="hoy">Hoy</option><option value="7d">Últimos 7 días</option><option value="30d">Últimos 30 días</option><option value="all">Todo el periodo</option></select>},
                    ].map(f=>(
                      <div key={f.label}><div style={{fontSize:10,color:'#bbb',fontWeight:700,marginBottom:8,textTransform:'uppercase',letterSpacing:'0.12em'}}>{f.label}</div>{f.el}</div>
                    ))}
                  </div>
                  <div style={{display:'flex',gap:10,marginTop:24}}>
                    <button onClick={()=>{setTienda('Todas las tiendas');setTransportadora('Todas');setMetodoPago('Todos');setShowFilters(false);}} style={{flex:1,padding:'12px',borderRadius:14,border:'1.5px solid #e8e8e6',background:'#fff',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'inherit',color:'#666',transition:'all 0.25s cubic-bezier(0.32,0.72,0,1)'}}>Limpiar</button>
                    <button onClick={()=>setShowFilters(false)} style={{flex:1,padding:'12px',borderRadius:14,border:'none',background:'#0a0a0a',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'inherit',color:'#fff',transition:'all 0.25s cubic-bezier(0.32,0.72,0,1)'}}>Aplicar</button>
                  </div>
                </div>
              </div>
            )}

            <div className="ord-wrap">
            {/* HEADER */}
            <div className="page-head">
              <div>
                <div className="page-title">Pedidos</div>
                <div className="page-sub">Gestiona y controla todos tus pedidos en un solo lugar.</div>
              </div>
              <select className="daterange" value={dateRange} onChange={e=>applyDateRange(e.target.value)}>
                <option value="hoy">Hoy</option>
                <option value="7d">Últimos 7 días</option>
                <option value="30d">Últimos 30 días</option>
                <option value="all">Todo el periodo</option>
              </select>
            </div>

            {/* KPIs */}
            <div className="metrics-row">
              {[
                { label:'Ingresos',      val: loading?'...':fmt(totalVentas), sub:'Ventas del periodo', color:'#6D5AE0', bg:'#F1EEFC',
                  icon:<path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/> },
                { label:'Pedidos',       val: loading?'...':totalPedidos, sub:'Total en vista', color:'#4F79C7', bg:'#EAF0FA',
                  icon:<><path d="M16.5 9.4 7.5 4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.27 6.96 12 12.01l8.73-5.05"/></> },
                { label:'Sin despachar', val: loading?'...':sinDespachar, sub:'Pendientes de guía', color:'#B45309', bg:'#FBF1E3',
                  icon:<><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></> },
                { label:'Despachados',   val: loading?'...':despachados, sub:'En tránsito', color:'#4F79C7', bg:'#EAF0FA',
                  icon:<><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></> },
                { label:'Entregados',    val: loading?'...':entregados, sub:'Confirmados', color:'#16A34A', bg:'#E7F6EC',
                  icon:<><path d="M20 6 9 17l-5-5"/></> },
                { label:'Novedades',     val: loading?'...':novedades, sub:'Requieren atención', color:'#DC2626', bg:'#FBEAEA',
                  icon:<><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></> },
              ].map(k=>(
                <div className="m-card" key={k.label}>
                  <div className="kpi-ic" style={{background:k.bg}}>
                    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke={k.color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{k.icon}</svg>
                  </div>
                  <div className="m-label">{k.label}</div>
                  <div className="m-val">{k.val}</div>
                  <div className="m-sub">{k.sub}</div>
                </div>
              ))}
            </div>

            {/* ESTADOS + FILTROS */}
            <div className="fbar">
              <div className="tabs">
                {TABS.map(t=>(
                  <button key={t.id}
                    className={`tab${tabEstado===t.id?' tab--active':''}`}
                    onClick={()=>{
                      setTabEstado(t.id);
                      if (t.id === 'abandonados' && abandonados.length === 0) loadAbandonados();
                    }}
                    style={t.special && tabEstado!==t.id ? {color:'#B45309'} : {}}>
                    {t.label}
                    <span className="tab__count" style={t.special && tabEstado===t.id ? {background:'rgba(255,255,255,0.25)'} : {}}>{t.count}</span>
                  </button>
                ))}
              </div>
              <div className="srow">
                <div className="sbox">
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="5" stroke="#9CA3AF" strokeWidth="1.5"/><path d="M11 11l3 3" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round"/></svg>
                  <input placeholder="Buscar por pedido, cliente o producto..." value={search} onChange={e=>{setSearch(e.target.value);}}/>
                </div>
                <button className="fbtn" onClick={()=>setShowFilters(true)}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="1.8" strokeLinecap="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>Filtros
                  {(tienda!=='Todas las tiendas'||transportadora!=='Todas'||metodoPago!=='Todos') && <span style={{width:7,height:7,borderRadius:'50%',background:'#6D5AE0'}}/>}
                </button>
                <select className="fsel" value={tienda} onChange={e=>{setTienda(e.target.value);}}>
                  {TIENDAS.map(t=><option key={t}>{t}</option>)}
                </select>
                <button className="fbtn" onClick={()=>{
                  const csv=['ID,Cliente,Producto,Tienda,Valor,Metodo,Estado,Fecha',...filtered.map(o=>`${o.id},${o.cliente},${o.producto},${o.tienda},${o.valor},${o.metodo},${getEstado(o)},${o.fecha}`)].join('\n');
                  const a=document.createElement('a');a.href=URL.createObjectURL(new Blob([csv],{type:'text/csv'}));a.download='pedidos_talku.csv';a.click();
                }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="1.8" strokeLinecap="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>Exportar
                </button>
                <button className="fbtn fbtn--primary" onClick={()=>setShowNuevoPedido(true)}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>Nuevo pedido
                </button>
              </div>
            </div>

            {/* LAYOUT DOS COLUMNAS: tabla + drawer persistente */}
            <div className="ord-split">
            <div className="ord-left">
            {/* TABLA ABANDONADOS */}
            {tabEstado === 'abandonados' && (
              <div className="tw">
                <div style={{display:'grid',gridTemplateColumns:'2fr 1.2fr 2fr 100px 110px 120px',gap:0,padding:'0 20px',height:48,alignItems:'center',borderBottom:'2px solid #f0f0ee'}}>
                  {['Cliente','Telefono','Producto','Valor','Hace cuanto',''].map(h=>(
                    <div key={h} style={{fontSize:10,fontWeight:700,color:'#bbb',textTransform:'uppercase',letterSpacing:'0.14em'}}>{h}</div>
                  ))}
                </div>
                {loadingAbandonados ? (
                  <div className="ld"><div className="spin"/>Consultando Shopify...</div>
                ) : abandonados.length === 0 ? (
                  <div style={{padding:'64px',textAlign:'center',color:'#ccc',fontSize:14,fontWeight:500}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ddd" strokeWidth="1.2" strokeLinecap="round" style={{marginBottom:12,display:'block',margin:'0 auto 12px'}}><circle cx="12" cy="12" r="10"/><path d="M8 15h8"/><circle cx="9" cy="9" r="1" fill="#ddd"/><circle cx="15" cy="9" r="1" fill="#ddd"/></svg>
                    No hay checkouts abandonados en los ultimos 5 dias
                  </div>
                ) : abandonados.map(ch => {
                  const mins = Math.floor((Date.now() - new Date(ch.created_at).getTime()) / 60000);
                  const timeAgo = mins < 60 ? `hace ${mins} min` : mins < 1440 ? `hace ${Math.floor(mins/60)}h` : `hace ${Math.floor(mins/1440)}d`;
                  return (
                    <div key={ch.token} style={{display:'grid',gridTemplateColumns:'2fr 1.2fr 2fr 100px 110px 120px',gap:0,padding:'0 20px',height:64,alignItems:'center',borderBottom:'1px solid #f6f6f4',transition:'all 0.25s cubic-bezier(0.32,0.72,0,1)',cursor:'pointer',position:'relative'}}
                      onClick={()=>{setSelectedAbandoned(ch);setRecoverMsg('');}}
                      onMouseEnter={e=>e.currentTarget.style.background='#fafaf9'}
                      onMouseLeave={e=>e.currentTarget.style.background=''}>
                      <div>
                        <div style={{fontSize:13,fontWeight:600,color:'#0a0a0a',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{ch.name || ch.email || 'Sin nombre'}</div>
                        <div style={{fontSize:11,color:'#bbb',marginTop:2}}>{ch.email}</div>
                      </div>
                      <div style={{fontSize:13,color:'#0a0a0a',fontWeight:500}}>{ch.phone || <span style={{color:'#ddd'}}>Sin telefono</span>}</div>
                      <div>
                        <div style={{fontSize:13,color:'#0a0a0a',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',fontWeight:500}}>{ch.product}</div>
                        <div style={{fontSize:11,color:'#bbb',marginTop:2}}>{ch.variant}</div>
                      </div>
                      <div style={{fontSize:13,fontWeight:700,color:'#0a0a0a'}}>{fmt(ch.total)}</div>
                      <div style={{fontSize:12,color:'#999',fontWeight:500}}>{timeAgo}</div>
                      <div style={{display:'flex',gap:6}}>
                        {ch.has_phone ? (
                          <div style={{padding:'5px 12px',borderRadius:999,background:'#fffbeb',border:'1px solid #fde68a',fontSize:10,fontWeight:700,color:'#92400e',cursor:'default',whiteSpace:'nowrap',letterSpacing:'0.02em'}}>
                            Template pendiente
                          </div>
                        ) : (
                          <div style={{padding:'5px 12px',borderRadius:999,background:'#f4f4f2',fontSize:10,color:'#ccc',whiteSpace:'nowrap',fontWeight:600}}>Sin telefono</div>
                        )}
                      </div>
                    </div>
                  );
                })}
                <div style={{padding:'16px 24px',borderTop:'1px solid #f0f0ee',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <div style={{fontSize:12,color:'#bbb',fontWeight:500}}>{abandonados.length} abandonados en los ultimos 5 dias</div>
                  <button onClick={loadAbandonados} className="fbtn">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="1.8" strokeLinecap="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
                    Actualizar
                  </button>
                </div>
              </div>
            )}

            {/* TABLA NORMAL */}
            {tabEstado !== 'abandonados' && <div className={`tw${splitView?' tw--split':''}`}>
              <div className="tw__hdr">
                <div className="tw__th"></div>
                <div className="tw__th">Pedido</div>
                <div className="tw__th">Cliente</div>
                <div className="tw__th">Producto</div>
                <div className="tw__th">Valor</div>
                <div className="tw__th">Estado</div>
                {!splitView && <div className="tw__th">Fecha</div>}
                <div className="tw__th"></div>
              </div>

              {loading ? (
                <div className="ld">
                  <div className="spin"/>
                  Cargando pedidos de Shopify...
                </div>
              ) : filtered.length === 0 ? (
                <div style={{padding:'64px',textAlign:'center',color:'#ccc',fontSize:14,fontWeight:500}}>
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ddd" strokeWidth="1.2" strokeLinecap="round" style={{display:'block',margin:'0 auto 12px'}}><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
                  No se encontraron pedidos
                </div>
              ) : <div className="tw__body">{filtered.map(o => {
                const estado = getEstado(o);
                const est = ESTADO_CONFIG[estado] || ESTADO_CONFIG.sin_confirmar;
                const prodName = o.producto && o.producto !== '—' ? o.producto : (o.items_detalle?.[0]?.producto || '—');
                const prodVar = o.variante && o.variante !== '—' ? o.variante : (o.items_detalle?.[0]?.variante || '');
                const qty = o.cantidad || o.items_detalle?.reduce((s,it)=>s+(it.cantidad||1),0) || 1;
                const subline = [prodVar && prodVar!=='—' ? prodVar : null, qty>1?`x${qty}`:null].filter(Boolean).join(' · ');
                return (
                  <div key={o.id} className={`tw__row${selectedOrder?.uid===o.uid?' tw__row--sel':''}`} onClick={()=>setSelectedOrder(o)}>
                    <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                      {o.novedad && <div className="nov-dot"/>}
                    </div>
                    <div className="tw__td" style={{display:'flex',alignItems:'center',gap:5}}>
                      <span style={{fontWeight:700}}>{o.id}</span>
                      <CanalIcon c={o.canal||'wa'}/>
                    </div>
                    <div className="tw__td" style={{fontWeight:600}}>{o.cliente}</div>
                    <div style={{display:'flex',alignItems:'center',gap:11,paddingRight:8,minWidth:0}}>
                      <ProdThumb src={o.foto || o.items_detalle?.[0]?.image_url} name={prodName} size={48} radius={12}/>
                      <div style={{minWidth:0}}>
                        <div style={{fontSize:13,color:'#0F0F10',fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{prodName}</div>
                        {subline && <div style={{fontSize:11,color:'#9CA3AF',marginTop:2,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{subline}</div>}
                      </div>
                    </div>
                    <div style={{paddingRight:8,minWidth:0}}>
                      <div style={{fontSize:13,fontWeight:700,color:'#0F0F10'}}>{fmt(o.valor||0)}</div>
                      <div style={{fontSize:11,color:'#9CA3AF',marginTop:2,fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{normMetodo(o.metodo)}</div>
                    </div>
                    <div onClick={e=>e.stopPropagation()}>
                      <span className="badge" style={{background:est.bg,color:est.color}}>
                        <span style={{width:6,height:6,borderRadius:'50%',background:est.color,flexShrink:0}}/>
                        {est.label}
                      </span>
                    </div>
                    {!splitView && <div className="tw__td tw__td--muted">{o.fecha}</div>}
                    <div className="rdots" style={{position:'relative'}} onClick={e=>{
                      e.stopPropagation();
                      if(orderMenuId===o.id){setOrderMenuId(null);return;}
                      const rect=e.currentTarget.getBoundingClientRect();
                      setMenuPos({top:rect.bottom+4,left:rect.right-220});
                      setOrderMenuId(o.id);
                    }}>
                      <div style={{width:34,height:34,borderRadius:10,border:'1px solid #E8E8E8',background:'#fff',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',transition:'background 0.2s'}} onMouseEnter={e=>e.currentTarget.style.background='#F5F5F3'} onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.7" strokeLinecap="round"><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></svg>
                      </div>
                    </div>
                  </div>
                );
              })}</div>}

            </div>}
            </div>{/* /ord-left */}

            {splitView && (() => {
              const o = selectedOrder;
              const est = ESTADO_CONFIG[getEstado(o)] || ESTADO_CONFIG.sin_confirmar;
              const items = (o.items_detalle && o.items_detalle.length > 0)
                ? o.items_detalle
                : [{producto:o.producto, variante:o.variante, cantidad:o.cantidad||1, precio:o.valor, image_url:o.foto}];
              const iconH = (d) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{d}</svg>;
              const ciudadDep = [o.ciudad&&o.ciudad!=='—'?o.ciudad:null, o.provincia].filter(Boolean).join(', ') || '—';
              const guia = o.guia || o.guia_nexus || null;
              // Eventos de historial realmente disponibles
              const timeline = [
                o.fecha ? {t:'Pedido creado', d:o.fecha} : null,
                o.confirmed_at ? {t:'Confirmación', d:o.confirmed_at} : null,
                guia ? {t:'Despacho / guía generada', d:guia} : null,
                o.carrier_last_update ? {t:est.label, d:o.carrier_last_update} : null,
              ].filter(Boolean);
              return (
              <div className="dpanel">
                <div className="dp-hdr">
                  <div>
                    <div className="dp-title">Pedido {o.id}</div>
                    <div style={{display:'flex',alignItems:'center',gap:8,marginTop:7}}>
                      <span className="badge" style={{background:est.bg,color:est.color}}>
                        <span style={{width:6,height:6,borderRadius:'50%',background:est.color}}/>{est.label}
                      </span>
                      <span style={{fontSize:12,color:'#9CA3AF',fontWeight:500}}>{o.fecha}</span>
                    </div>
                  </div>
                  <div className="dp-x" onClick={()=>setSelectedOrder(null)}>×</div>
                </div>
                <div className="dp-body">

                  {o.source === 'contingency' && (
                    <div style={{background:'#FBF1E3',border:'1px solid #f0dcc0',borderRadius:14,padding:16}}>
                      <div style={{fontSize:13,fontWeight:700,color:'#B45309'}}>Pendiente de sincronización</div>
                      <div style={{fontSize:12,color:'#92702a',marginTop:4,lineHeight:1.5}}>Pedido de contingencia (aún no está en Nexus). Sincronízalo para convertirlo en pedido definitivo.</div>
                      {o.sync_error && <div style={{fontSize:12,color:'#DC2626',marginTop:6}}>Error previo: {o.sync_error}</div>}
                      {syncMsg && <div style={{fontSize:12,color:'#DC2626',marginTop:6}}>{syncMsg}</div>}
                      <button className="dp-btn dp-btn--lav" style={{marginTop:12,width:'100%'}} onClick={syncContingency} disabled={syncing}>
                        {syncing ? 'Sincronizando…' : 'Sincronizar ahora'}
                      </button>
                    </div>
                  )}

                  {/* A. CLIENTE */}
                  <div className="dp-sec">
                    <div className="dp-sec-h">{iconH(<><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></>)}Cliente</div>
                    <div className="dp-card">
                      <div className="dp-row"><span className="dp-lbl">Nombre</span><span className="dp-val">{o.cliente||'—'}</span></div>
                      <div className="dp-row"><span className="dp-lbl">Teléfono</span><span className="dp-val">{o.telefono||'—'}</span></div>
                      {o.email && <div className="dp-row"><span className="dp-lbl">Email</span><span className="dp-val">{o.email}</span></div>}
                      <div className="dp-row"><span className="dp-lbl">Ciudad / depto.</span><span className="dp-val">{ciudadDep}</span></div>
                    </div>
                    <div style={{display:'flex',gap:8}}>
                      <button className="dp-btn dp-btn--sm" style={{flex:1}} onClick={()=>handleNav('Contactos', o.telefono)}>Ver en CRM</button>
                      <button className="dp-btn dp-btn--sm" style={{flex:1}} onClick={()=>{handleNav('Conversaciones', o.telefono);}}>Enviar mensaje</button>
                    </div>
                  </div>

                  {/* B. PRODUCTO */}
                  <div className="dp-sec">
                    <div className="dp-sec-h">{iconH(<><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></>)}Producto</div>
                    {items.map((it,idx)=>(
                      <div className="dp-card" key={idx} style={{display:'flex',gap:14}}>
                        <ProdThumb src={it.image_url || o.foto} name={it.producto} size={64} radius={12}/>
                        <div style={{minWidth:0,flex:1}}>
                          <div style={{fontSize:13,fontWeight:600,color:'#0F0F10',lineHeight:1.3}}>{it.producto&&it.producto!=='—'?it.producto:'Producto sin detalle'}</div>
                          {it.variante && it.variante!=='—' && <div style={{fontSize:12,color:'#6B7280',marginTop:4}}>{it.variante}</div>}
                          <div style={{display:'flex',justifyContent:'space-between',alignItems:'baseline',marginTop:10}}>
                            <span style={{fontSize:12,color:'#6B7280',fontWeight:600}}>Cant. {it.cantidad||1}</span>
                            <span style={{fontSize:14,fontWeight:700,color:'#0F0F10'}}>{fmt(it.precio||0)}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* C. PAGO */}
                  <div className="dp-sec">
                    <div className="dp-sec-h">{iconH(<><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></>)}Pago</div>
                    <div className="dp-card">
                      <div className="dp-row"><span className="dp-lbl">Método de pago</span><span className="dp-val">{normMetodo(o.metodo)}</span></div>
                      <div className="dp-row"><span className="dp-lbl">Estado de pago</span><span className="dp-val">{(ESTADO_CONFIG[o.estado_pago]?.label)||o.estado_pago||'—'}</span></div>
                    </div>
                  </div>

                  {/* D. RESUMEN */}
                  <div className="dp-sec">
                    <div className="dp-sec-h">{iconH(<><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></>)}Resumen</div>
                    <div className="dp-card">
                      {o.subtotal != null && <div className="dp-row"><span className="dp-lbl">Subtotal</span><span className="dp-val">{fmt(o.subtotal)}</span></div>}
                      {o.envio != null && <div className="dp-row"><span className="dp-lbl">Envío</span><span className="dp-val">{o.envio>0?fmt(o.envio):'Gratis'}</span></div>}
                      <div className="dp-row" style={{marginTop:(o.subtotal!=null||o.envio!=null)?12:0,paddingTop:(o.subtotal!=null||o.envio!=null)?12:0,borderTop:(o.subtotal!=null||o.envio!=null)?'1px solid #F0F0F0':'none'}}>
                        <span className="dp-lbl" style={{fontWeight:700,color:'#0F0F10',fontSize:13}}>Total</span>
                        <span style={{fontSize:19,fontWeight:800,color:'#0F0F10',letterSpacing:'-0.5px'}}>{fmt(o.valor||0)}</span>
                      </div>
                    </div>
                  </div>

                  {/* E. ENVÍO */}
                  <div className="dp-sec">
                    <div className="dp-sec-h">{iconH(<><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></>)}Envío</div>
                    <div className="dp-card">
                      <div className="dp-row"><span className="dp-lbl">Dirección</span><span className="dp-val">{o.direccion||'—'}</span></div>
                      <div className="dp-row"><span className="dp-lbl">Ciudad</span><span className="dp-val">{o.ciudad||'—'}</span></div>
                      <div className="dp-row"><span className="dp-lbl">Departamento</span><span className="dp-val">{o.provincia||'—'}</span></div>
                      <div className="dp-row"><span className="dp-lbl">Transportadora</span><span className="dp-val">{o.transportadora||'—'}</span></div>
                      <div className="dp-row"><span className="dp-lbl">Guía</span><span className="dp-val">{o.tracking_url&&guia?<a href={o.tracking_url} target="_blank" rel="noreferrer" style={{color:'#6D5AE0',textDecoration:'none',fontWeight:700}}>{guia}</a>:(guia||'—')}</span></div>
                      <div className="dp-row"><span className="dp-lbl">Estado de envío</span><span className="dp-val">{o.estado_envio==='fulfilled'?'Despachado':o.estado_envio==='sin_despachar'?'Sin despachar':(o.estado_envio||'—')}</span></div>
                    </div>
                  </div>

                  {/* F. HISTORIAL */}
                  {timeline.length > 0 && (
                    <div className="dp-sec">
                      <div className="dp-sec-h">{iconH(<><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>)}Historial</div>
                      <div className="dp-card">
                        <div className="tl">
                          {timeline.map((ev,i)=>(
                            <div className="tl-item" key={i}>
                              <div className="tl-t">{ev.t}</div>
                              <div className="tl-d">{ev.d}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* ACCIONES */}
                  <div className="dp-sec">
                    {drawerEstadoOpen && (
                      <div className="dp-card" style={{padding:10}}>
                        <div style={{fontSize:10,fontWeight:700,color:'#9CA3AF',textTransform:'uppercase',letterSpacing:'0.1em',padding:'4px 6px 8px'}}>Cambiar estado</div>
                        <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
                          {['despachado','en_camino','en_destino','en_reparto','entregado','novedad','devolucion','cancelado'].map(k=>(
                            <button key={k} className="dp-btn dp-btn--sm" onClick={()=>{changeEstado(o.id,k);setDrawerEstadoOpen(false);}} style={{gap:6}}>
                              <span style={{width:7,height:7,borderRadius:'50%',background:ESTADO_CONFIG[k].color}}/>{ESTADO_CONFIG[k].label}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
                      {o.shopify_id && <button className="dp-btn dp-btn--lav" style={{gridColumn:'span 2'}} onClick={()=>openNexusModal(o.shopify_id)}>
                        {o.guia_nexus ? 'Ver guía Nexus' : 'Generar guía'}
                      </button>}
                      <button className="dp-btn" onClick={()=>setDrawerEstadoOpen(v=>!v)}>Actualizar estado</button>
                      <button className="dp-btn" onClick={()=>o.shopify_id ? openNexusModal(o.shopify_id) : setTabEstado('novedad')}>Novedad</button>
                      <button className="dp-btn" onClick={()=>{handleNav('Conversaciones', o.telefono);}}>Abrir conversación</button>
                      {o.shopify_id && <button className="dp-btn" onClick={()=>storeDomain && window.open(`https://admin.shopify.com/store/${storeDomain.replace('.myshopify.com','')}/orders/${o.shopify_id}`,'_blank')}>Ver en Shopify</button>}
                      <button className="dp-btn dp-btn--danger" style={{gridColumn:'span 2'}} onClick={()=>{changeEstado(o.id,'cancelado');setSelectedOrder(null);}}>Cancelar pedido</button>
                    </div>
                  </div>

                </div>
              </div>
              );
            })()}
            </div>{/* /ord-split */}
            </div>{/* /ord-wrap */}
          </div>
        </div>
        </div>
      </div>

      {/* MODAL NEXUS */}
      {showNexusModal && (
        <div className="mov" style={{zIndex:600}} onClick={()=>{ setShowNexusModal(false); setNexusMsg(''); setNexusNovedades([]); setSelectedSolucion(null); setDetalleForm({}); }}>
          <div className="mod" style={{width:480}} onClick={e=>e.stopPropagation()}>
            <div className="mod__hdr">
              <div style={{display:'flex',alignItems:'center',gap:12}}>
                <div style={{width:40,height:40,borderRadius:12,background:'#fef2f2',display:'flex',alignItems:'center',justifyContent:'center'}}>
                  <img src="/nexus-logo.png" alt="Nexus" style={{width:24,height:24,objectFit:'contain'}}/>
                </div>
                <div>
                  <div className="mod__title" style={{fontSize:20}}>Generar guia</div>
                  <div style={{fontSize:12,color:'#bbb',marginTop:3,fontWeight:500}}>
                    {nexusOrderInfo?.tracking_number
                      ? `Guia actual: ${nexusOrderInfo.tracking_number}`
                      : nexusOrderInfo?.has_nexus ? 'Sin guia generada' : 'Pedido no vinculado a Nexus'}
                  </div>
                </div>
              </div>
              <div className="mod__close" onClick={()=>{ setShowNexusModal(false); setNexusMsg(''); setNexusNovedades([]); setSelectedSolucion(null); setDetalleForm({}); }}>x</div>
            </div>

            {nexusLoading && !nexusMsg && (
              <div style={{display:'flex',justifyContent:'center',padding:'28px 0'}}>
                <div className="spin"/>
              </div>
            )}

            {nexusMsg && (
              <div style={{
                background: nexusMsg.includes('generada') || nexusMsg.includes('resuelta') ? '#f0fdf4' : nexusMsg.includes('activa') ? '#fffbeb' : '#fef2f2',
                border: `1.5px solid ${nexusMsg.includes('generada') || nexusMsg.includes('resuelta') ? '#bbf7d0' : nexusMsg.includes('activa') ? '#fde68a' : '#fee2e2'}`,
                borderRadius:14, padding:'12px 16px', marginBottom:16, fontSize:13, fontWeight:600,
                color: nexusMsg.includes('generada') || nexusMsg.includes('resuelta') ? '#16a34a' : nexusMsg.includes('activa') ? '#92400e' : '#ef4444',
              }}>{nexusMsg}</div>
            )}

            {!nexusOrderInfo?.has_nexus && !nexusLoading && (
              <div style={{background:'#fef9c3',border:'1.5px solid #fde68a',borderRadius:14,padding:'14px 16px',fontSize:13,color:'#92400e',marginBottom:16,fontWeight:500}}>
                Este pedido aun no esta vinculado a Nexus. Espera a que llegue el webhook de <strong>nueva_orden</strong>.
              </div>
            )}

            {nexusOrderInfo?.has_nexus && nexusOrderInfo?.tracking_number && (
              <div style={{textAlign:'center',padding:'20px 0 8px'}}>
                <div style={{fontSize:11,color:'#bbb',marginBottom:10,fontWeight:700,textTransform:'uppercase',letterSpacing:'0.12em'}}>Guia generada</div>
                <a href={`https://www.coordinadora.com/portafolio-de-servicios/servicios-en-linea/rastrear-guias/?guia=${nexusOrderInfo.tracking_number}`}
                  target="_blank" rel="noreferrer"
                  style={{fontSize:24,fontWeight:800,color:'#f90370',textDecoration:'none',letterSpacing:1.5}}>
                  {nexusOrderInfo.tracking_number}
                </a>
                <div style={{marginTop:20,display:'flex',gap:10,justifyContent:'center'}}>
                  <button onClick={async()=>{
                    try {
                      const r = await fetch(`${API}/nexus/orders/${nexusOrderInfo.shopify_order_id}/label`, { headers: authH() });
                      const d = await r.json();
                      if (d.pdf_b64) {
                        const w = window.open('');
                        w.document.write(`<iframe src="data:application/pdf;base64,${d.pdf_b64}" style="width:100%;height:100vh;border:none;"></iframe>`);
                      } else { alert('PDF no disponible aun'); }
                    } catch { alert('Error al obtener el PDF'); }
                  }} style={{padding:'11px 22px',borderRadius:14,border:'none',background:'#0a0a0a',color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'inherit',display:'flex',alignItems:'center',gap:8,transition:'all 0.3s cubic-bezier(0.32,0.72,0,1)'}}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>
                    Ver guia PDF
                  </button>
                  <button onClick={()=>{ setShowNexusModal(false); setNexusMsg(''); setNexusNovedades([]); setSelectedSolucion(null); setDetalleForm({}); }}
                    style={{padding:'11px 22px',borderRadius:14,border:'1.5px solid #e8e8e6',background:'#fff',color:'#666',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:'inherit',transition:'all 0.3s cubic-bezier(0.32,0.72,0,1)'}}>
                    Cerrar
                  </button>
                </div>
              </div>
            )}

            {nexusNovedades.length > 0 && (
              <div style={{marginBottom:16}}>
                <div style={{fontSize:10,fontWeight:700,color:'#ef4444',marginBottom:12,textTransform:'uppercase',letterSpacing:'0.12em'}}>Novedades pendientes ({nexusNovedades.length})</div>
                {nexusNovedades.map(nov => {
                  const nid = nov.id || nov.codigo;
                  const isOpen = resolving === null && selectedSolucion?.novedadId === nid;
                  return (
                    <div key={nid} style={{background:'#fef2f2',border:'1.5px solid #fee2e2',borderRadius:16,padding:'14px 16px',marginBottom:10}}>
                      <div style={{fontSize:13,fontWeight:700,color:'#0a0a0a',marginBottom:3}}>{nov.descripcion || nov.tipo || 'Novedad'}</div>
                      {nov.fecha && <div style={{fontSize:11,color:'#bbb',marginBottom:10}}>{String(nov.fecha).slice(0,16).replace('T',' ')}</div>}
                      {nov.soluciones_posibles?.length > 0 && (
                        <div>
                          <div style={{fontSize:10,fontWeight:700,color:'#999',marginBottom:8,textTransform:'uppercase',letterSpacing:'0.1em'}}>Soluciones disponibles:</div>
                          <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:isOpen?12:0}}>
                            {nov.soluciones_posibles.map(sol => (
                              <button key={sol.id} onClick={() => { setSelectedSolucion({ ...sol, novedadId: nid }); setDetalleForm({}); }}
                                style={{padding:'7px 14px',borderRadius:10,border: selectedSolucion?.id === sol.id && selectedSolucion?.novedadId === nid ? '2px solid #0a0a0a' : '1.5px solid #e8e8e6',
                                  background: selectedSolucion?.id === sol.id && selectedSolucion?.novedadId === nid ? '#0a0a0a' : '#fff',
                                  color: selectedSolucion?.id === sol.id && selectedSolucion?.novedadId === nid ? '#fff' : '#0a0a0a',
                                  fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:'inherit',transition:'all 0.25s cubic-bezier(0.32,0.72,0,1)'}}>
                                {sol.nombre || sol.label || `Solucion ${sol.id}`}
                              </button>
                            ))}
                          </div>
                          {isOpen && (
                            <div>
                              <div style={{fontSize:10,color:'#999',marginBottom:8,fontWeight:700,textTransform:'uppercase',letterSpacing:'0.1em'}}>Detalle (opcional):</div>
                              {[{k:'direccion',l:'Direccion'},{k:'destinatario',l:'Destinatario'},{k:'telefono',l:'Telefono'}].map(({k,l})=>(
                                <input key={k} placeholder={l} value={detalleForm[k]||''}
                                  onChange={e=>setDetalleForm(p=>({...p,[k]:e.target.value}))}
                                  className="nxinp"
                                  style={{width:'100%',padding:'9px 14px',border:'1.5px solid #e8e8e6',borderRadius:12,fontSize:12,fontFamily:'inherit',outline:'none',marginBottom:8,transition:'border-color 0.25s'}}
                                  onFocus={e=>e.target.style.borderColor='#6D5AE0'} onBlur={e=>e.target.style.borderColor='#e8e8e6'}/>
                              ))}
                              <button disabled={resolving===nid} onClick={()=>resolveNovelty(nid)}
                                style={{width:'100%',padding:'10px 0',borderRadius:12,border:'none',background:resolving===nid?'#888':'#16a34a',color:'#fff',
                                  fontSize:12,fontWeight:700,cursor:resolving===nid?'not-allowed':'pointer',fontFamily:'inherit',marginTop:4,transition:'all 0.25s cubic-bezier(0.32,0.72,0,1)'}}>
                                {resolving===nid ? 'Resolviendo...' : 'Confirmar solucion'}
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            {nexusOrderInfo?.has_nexus && !nexusOrderInfo?.tracking_number && (
              <div>
                {[
                  { key: 'customer_name',       label: 'Nombre cliente' },
                  { key: 'customer_phone',      label: 'Telefono' },
                  { key: 'shipping_address',    label: 'Direccion' },
                  { key: 'city',               label: 'Ciudad' },
                  { key: 'state',              label: 'Departamento' },
                  { key: 'content_description', label: 'Descripcion contenido' },
                  { key: 'total_amount',        label: 'Valor a pagar (COP)' },
                ].map(({ key, label }) => (
                  <div key={key} style={{marginBottom:12}}>
                    <div style={{fontSize:10,fontWeight:700,color:'#bbb',marginBottom:6,textTransform:'uppercase',letterSpacing:'0.12em'}}>{label}</div>
                    <input
                      value={nexusForm[key] || ''}
                      onChange={e => setNexusForm(prev => ({ ...prev, [key]: e.target.value }))}
                      placeholder={label}
                      style={{width:'100%',padding:'10px 14px',border:'1.5px solid #e8e8e6',borderRadius:12,fontSize:13,fontFamily:'inherit',outline:'none',fontWeight:500,transition:'border-color 0.25s cubic-bezier(0.32,0.72,0,1)'}}
                      onFocus={e=>e.target.style.borderColor='#6D5AE0'}
                      onBlur={e=>e.target.style.borderColor='#e8e8e6'}
                    />
                  </div>
                ))}
                <div style={{display:'flex',gap:10,marginTop:8}}>
                  <button onClick={()=>{ setShowNexusModal(false); setNexusMsg(''); setNexusNovedades([]); setSelectedSolucion(null); setDetalleForm({}); }}
                    style={{flex:1,padding:'12px 0',borderRadius:14,border:'1.5px solid #e8e8e6',background:'#fff',color:'#666',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:'inherit',transition:'all 0.3s cubic-bezier(0.32,0.72,0,1)'}}>
                    Cancelar
                  </button>
                  <button disabled={nexusLoading} onClick={nexusGenerateGuide}
                    style={{flex:2,padding:'12px 0',borderRadius:14,border:'none',background:nexusLoading?'#666':'#f90370',color:'#fff',fontSize:13,fontWeight:700,cursor:nexusLoading?'not-allowed':'pointer',fontFamily:'inherit',display:'flex',alignItems:'center',justifyContent:'center',gap:8,transition:'all 0.3s cubic-bezier(0.32,0.72,0,1)'}}>
                    {nexusLoading
                      ? <><div className="spin" style={{width:14,height:14,borderWidth:2}}/> Generando...</>
                      : <><img src="/nexus-logo.png" alt="" style={{width:16,height:16,objectFit:'contain',filter:'brightness(0) invert(1)'}}/> Generar guia</>
                    }
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}


      {/* MODAL ABANDONADO */}
      {selectedAbandoned && (
        <div className="mov" onClick={()=>setSelectedAbandoned(null)}>
          <div className="mod" onClick={e=>e.stopPropagation()}>
            <div className="mod__hdr">
              <div>
                <div className="mod__title">{selectedAbandoned.name || selectedAbandoned.email || 'Sin nombre'}</div>
                <div style={{display:'flex',alignItems:'center',gap:8,marginTop:6}}>
                  <span className="badge" style={{background:'#fffbeb',color:'#92400e'}}>
                    <span style={{width:6,height:6,borderRadius:'50%',background:'#d97706'}}/>
                    Abandonado
                  </span>
                  <span style={{fontSize:12,color:'#bbb',fontWeight:500}}>
                    {(() => {
                      const mins = Math.floor((Date.now() - new Date(selectedAbandoned.created_at).getTime()) / 60000);
                      return mins < 60 ? `hace ${mins} min` : mins < 1440 ? `hace ${Math.floor(mins/60)}h` : `hace ${Math.floor(mins/1440)}d`;
                    })()}
                  </span>
                </div>
              </div>
              <div className="mod__close" onClick={()=>setSelectedAbandoned(null)}>x</div>
            </div>

            <div className="mod__sec">
              <div className="mod__sec-title">Producto</div>
              <div style={{background:'#fafaf9',borderRadius:16,padding:'18px 20px',display:'flex',gap:14,alignItems:'center',border:'1px solid #f0f0ee'}}>
                {selectedAbandoned.image_url && (
                  <img src={selectedAbandoned.image_url} alt="" style={{width:56,height:56,borderRadius:12,objectFit:'cover',flexShrink:0}}/>
                )}
                <div>
                  <div style={{fontSize:15,fontWeight:700,color:'#0a0a0a',letterSpacing:'-0.3px'}}>{selectedAbandoned.product}</div>
                  <div style={{fontSize:12,color:'#999',marginTop:3,fontWeight:500}}>{selectedAbandoned.variant}</div>
                  <div style={{fontSize:20,fontWeight:800,color:'#0a0a0a',marginTop:10,letterSpacing:'-0.6px'}}>{fmt(selectedAbandoned.total)}</div>
                </div>
              </div>
            </div>

            <div className="mod__sec">
              <div className="mod__sec-title">Cliente</div>
              {[
                ['Nombre',      selectedAbandoned.name     || '—'],
                ['Telefono',    selectedAbandoned.phone    || '—'],
                ['Email',       selectedAbandoned.email    || '—'],
                ['Direccion',   selectedAbandoned.address  || '—'],
                ['Barrio',      selectedAbandoned.address2 || '—'],
                ['Ciudad',      selectedAbandoned.city     || '—'],
                ['Departamento',selectedAbandoned.province || '—'],
              ].map(([l,v])=>(
                <div key={l} className="mod__row">
                  <span className="mod__label">{l}</span>
                  <span className="mod__value">{v}</span>
                </div>
              ))}
            </div>

            <div className="mod__acts">
              {selectedAbandoned.has_phone ? (
                <button className="mod__btn" style={{background:'#0a0a0a',color:'#fff'}}
                  onClick={()=>{handleNav('Conversaciones', selectedAbandoned.phone);setSelectedAbandoned(null);}}>
                  Abrir conversacion
                </button>
              ) : (
                <button className="mod__btn" style={{background:'#f4f4f2',color:'#ccc',cursor:'not-allowed'}}>Sin telefono</button>
              )}
              <button className="mod__btn" style={{background:'#f6fbf0',color:'#5a8a00',border:'1.5px solid #96bf48'}}
                onClick={()=>window.open(selectedAbandoned.recovery_url,'_blank')}>
                Ver en Shopify
              </button>
              {recoverMsg && (
                <div style={{gridColumn:'span 2',padding:'10px 14px',borderRadius:12,fontSize:13,fontWeight:600,
                  background: recoverMsg.includes('correctamente') ? '#f0fdf4' : '#fef2f2',
                  color: recoverMsg.includes('correctamente') ? '#16a34a' : '#ef4444',
                  border: `1.5px solid ${recoverMsg.includes('correctamente') ? '#bbf7d0' : '#fee2e2'}`}}>
                  {recoverMsg}
                </div>
              )}
              <button
                className="mod__btn"
                disabled={recoverLoading || !selectedAbandoned?.has_phone}
                style={{gridColumn:'span 2',background:recoverLoading?'#666':'#16a34a',color:'#fff',cursor:recoverLoading?'not-allowed':'pointer',opacity:selectedAbandoned?.has_phone?1:0.5}}
                onClick={()=>recoverAbandoned(selectedAbandoned)}>
                {recoverLoading ? 'Enviando...' : 'Enviar template recuperacion'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
